import Vue from "vue";
import App from "./App.vue";
import "./assets/tailwind.css"; // Import Tailwind CSS
import router from "./router"; // Import the router
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import appPlugin from '@/plugins/app'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/vi'
import VueDocPreview from 'vue-doc-preview'
import 'moment/dist/locale/vi';
import './assets/styles.scss';
import vi from 'element-ui/lib/locale/lang/vi'

vi.el.table = {
  ...vi.el.table,
  clearFilter: 'Tất cả'
}
Vue.use(appPlugin)
Vue.component('VueDocPreview', VueDocPreview)
Vue.use(ElementUI, { locale })
Vue.use(ElementUI);
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success === false) {
      if (
        response.data.message === 'Token đã quá hạng sử dụng' ||
        response.data.message === 'Lỗi token' ||
        response.data.message === 'Token không hợp lệ hoặc đã bị đăng xuất ở thiết bị này'
      ) {
        Vue.prototype.$message.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.');
        localStorage.removeItem('uToken');
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(()=>{});
        }
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      Vue.prototype.$message.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.');
      localStorage.removeItem('uToken');
      if (router.currentRoute.path !== '/login') {
        router.push('/login').catch(()=>{});
      }
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = axios;
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
